import * as Sentry from "@sentry/angular";

import {bootstrapApplication} from '@angular/platform-browser';
import {appConfig} from './app/app.config';
import {AppComponent} from './app/app.component';
import {environment} from './environments/environment';

const ENVIRONMENT = environment.ENVIRONMENT
const SENTRY_DSN = environment.SENTRY_DSN

Sentry.init({
  dsn: SENTRY_DSN,
  environment: ENVIRONMENT,
  sendDefaultPii: true, // Adds request headers and IP for users
  integrations: [

    // Performance monitoring
    Sentry.browserTracingIntegration(),

    // Session Replay
    Sentry.replayIntegration()
  ],

  // Session Replay
  replaysSessionSampleRate: 0.1, // 10% of sessions
  replaysOnErrorSampleRate: 1.0, // 100% of sessions with errors
});

bootstrapApplication(AppComponent, appConfig)
  .catch((err) => console.error(err));
